import { Injectable } from '@angular/core'
import { IWsMessage, IWsMessageLibrary, WsMessageEventTypes } from './websocket.interface'
import { WebsocketCommandsService } from './websocketCommands.service'

@Injectable()
export class WebsocketMapperService {
  constructor(private websocketCommandsService: WebsocketCommandsService) {}

  map(message: IWsMessage<any> | IWsMessageLibrary<any>): void {
    // Проверяем наличие upload_uuid для определения типа сообщения
    if ('upload_uuid' in message.metadata) {
      this.handleLibraryMessage(message as IWsMessageLibrary<any>)
    } else {
      this.handleStandardMessage(message as IWsMessage<any>)
    }
  }

  private handleStandardMessage(message: IWsMessage<any>): void {
    switch (message.metadata.event) {
      // Task Events
      case WsMessageEventTypes.CREATE_TASK:
        this.websocketCommandsService.createTask(message)
        break
      case WsMessageEventTypes.DELETE_TASK:
        this.websocketCommandsService.deleteTask(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_TITLE:
        this.websocketCommandsService.updateTaskTitle(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_OWNER:
        this.websocketCommandsService.updateTaskOwner(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_DURATION:
        this.websocketCommandsService.updateTaskDuration(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_POINT:
        this.websocketCommandsService.updateTaskPoint(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_PRIORITY:
        this.websocketCommandsService.updateTaskPriority(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_STAGE:
        this.websocketCommandsService.updateTaskStage(message)
        break
      case WsMessageEventTypes.ADD_TASK_TAG:
        this.websocketCommandsService.addTaskTag(message)
        break
      case WsMessageEventTypes.DELETE_TASK_TAG:
        this.websocketCommandsService.deleteTaskTag(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_TAG:
        this.websocketCommandsService.updateTaskTag(message)
        break
      case WsMessageEventTypes.ADD_TASK_SUBSCRIBER:
        this.websocketCommandsService.addTaskSubscriber(message)
        break
      case WsMessageEventTypes.DELETE_TASK_SUBSCRIBER:
        this.websocketCommandsService.deleteTaskSubscriber(message)
        break
      case WsMessageEventTypes.REPLACE_TASK_SUBSCRIBER:
        this.websocketCommandsService.replaceTaskSubscriber(message)
        break
      case WsMessageEventTypes.TASK_BLOCKS_SORTED:
        this.websocketCommandsService.taskBlocksSorted(message)
        break

      // Task Subtask Group Events
      case WsMessageEventTypes.CREATE_TASK_SUBTASK_GROUP:
        this.websocketCommandsService.createTaskSubtaskGroup(message)
        break
      case WsMessageEventTypes.DELETE_TASK_SUBTASK_GROUP:
        this.websocketCommandsService.deleteTaskSubtaskGroup(message)
        break
      case WsMessageEventTypes.RENAME_TASK_SUBTASK_GROUP:
        this.websocketCommandsService.renameTaskSubtaskGroup(message)
        break
      case WsMessageEventTypes.CHANGE_GROUP_TASK_SUBTASK:
        this.websocketCommandsService.changeGroupTaskSubtask(message)
        break

      // Task Subtask Events
      case WsMessageEventTypes.CREATE_TASK_SUBTASK:
        this.websocketCommandsService.createTaskSubtask(message)
        break
      case WsMessageEventTypes.DELETE_TASK_SUBTASK:
        this.websocketCommandsService.deleteTaskSubtask(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_SUBTASK_ASSIGNEE:
        this.websocketCommandsService.updateTaskSubtaskAssignee(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_SUBTASK_TITLE:
        this.websocketCommandsService.updateTaskSubtaskTitle(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_SUBTASK_STATUS:
        this.websocketCommandsService.updateTaskSubtaskStatus(message)
        break
      case WsMessageEventTypes.BLOCKED_TASK_SUBTASK:
        this.websocketCommandsService.blockTaskSubtask(message)
        break
      case WsMessageEventTypes.UNBLOCKED_TASK_SUBTASK:
        this.websocketCommandsService.unblockTaskSubtask(message)
        break

      // Task Text Blocks Events
      case WsMessageEventTypes.CREATE_TASK_TEXT_BLOCK:
        this.websocketCommandsService.createTaskTextBlock(message)
        break
      case WsMessageEventTypes.CREATE_TASK_TEXT_BLOCKS:
        this.websocketCommandsService.createTaskTextBlocks(message)
        break
      case WsMessageEventTypes.DELETE_TASK_TEXT_BLOCK:
        this.websocketCommandsService.deleteTaskTextBlock(message)
        break
      case WsMessageEventTypes.UPDATE_TASK_TEXT_BLOCK:
        this.websocketCommandsService.updateTaskTextBlock(message)
        break

      // Stream Events
      case WsMessageEventTypes.UPDATE_STREAM:
        this.websocketCommandsService.updateStream(message)
        break

      // Project Events
      case WsMessageEventTypes.CREATE_PROJECT:
        this.websocketCommandsService.createProject(message)
        break
      case WsMessageEventTypes.UPDATE_PROJECT:
        this.websocketCommandsService.updateProject(message)
        break
      case WsMessageEventTypes.DELETE_PROJECT:
        this.websocketCommandsService.deleteProject(message)
        break

      // Project Roles Events
      case WsMessageEventTypes.CREATE_PROJECT_ROLE:
        this.websocketCommandsService.createProjectRole(message)
        break
      case WsMessageEventTypes.UPDATE_PROJECT_ROLE:
        this.websocketCommandsService.updateProjectRole(message)
        break
      case WsMessageEventTypes.DELETE_PROJECT_ROLE:
        this.websocketCommandsService.deleteProjectRole(message)
        break

      // Task Files Events
      case WsMessageEventTypes.CREATE_TASK_FILE:
        this.websocketCommandsService.createTaskFile(message)
        break
      case WsMessageEventTypes.DELETE_TASK_FILE:
        this.websocketCommandsService.deleteTaskFile(message)
        break
    }
  }

  private handleLibraryMessage(message: IWsMessageLibrary<any>): void {
    switch (message.metadata.event) {
      // Screen Recorder Events
      case WsMessageEventTypes.SCREEN_RECORDER_UPLOAD_TRANSCODING_PROGRESS:
        this.websocketCommandsService.updateVideoTranscodingData(message)
        break
      case WsMessageEventTypes.SCREEN_RECORDER_UPLOAD_SUMMARY_GENERATED:
        this.websocketCommandsService.changeUploadTitle(message)
        break
    }
  }
}
